import { FAST_API_URL, postOptions } from "../index";

export interface RuSyncLanguageStatus {
    status: "queued" | "running" | "success" | "failed" | string;
    error?: string | null;
}

export interface RuSyncStatus {
    job_id?: string;
    media: string;
    folder_num: number;
    status: "idle" | "queued" | "running" | "success" | "failed" | string;
    languages: Record<string, RuSyncLanguageStatus>;
    updated_at?: string;
}

export const getRuSyncStatusApi = async (mediaId: string, folderNum: number): Promise<RuSyncStatus> => {
    const response = await fetch(
        `${FAST_API_URL}/ru-sync?media=${encodeURIComponent(mediaId)}&folder_num=${folderNum}`,
    );
    if (!response.ok) throw new Error("Failed to load Russian sync status");
    return response.json();
};

export const retryRuSyncApi = async (jobId: string, mediaId: string): Promise<RuSyncStatus> => {
    const response = await fetch(`${FAST_API_URL}/ru-sync/${encodeURIComponent(jobId)}/retry?media=${encodeURIComponent(mediaId)}`, {
        ...postOptions,
        body: "{}",
    });
    if (!response.ok) throw new Error("Failed to retry Russian sync");
    return response.json();
};
